import React from 'react';
import CustomDatePicker from '../utils/CustomDatePicker';

const pad = (n) => String(n).padStart(2, '0');

// Date <-> "DD/MM/YYYY". CustomDatePicker string ile çalışır; biz dış dünyaya Date sözleşmesini koruruz.
const dateToStr = (date) =>
  date instanceof Date && !isNaN(date)
    ? `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
    : '';

const strToDate = (s) => {
  if (!s || s.length !== 10) return null;
  const [d, m, y] = s.split('/').map(Number);
  if (!d || !m || !y || y < 1000) return null;
  const dt = new Date(y, m - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d ? dt : null;
};

/**
 * Tarih giriş alanı — uygulamanın özel CustomDatePicker'ını (Türkçe takvim + otomatik biçimleyen
 * yazım) sarar; dışarıya Date nesnesi alıp veren sözleşmeyi korur.
 */
function TarihGirisi({ label, value, onChange, hint }) {
  // CustomDatePicker her tuşta string yayar. Parent'a YALNIZ tam+geçerli tarihte (ya da alan
  // boşaltılınca) yazarız. Kısmî/geçersiz girişte parent'a dokunmayız; aksi halde parent değeri
  // değişip CustomDatePicker'ın value→localDate senkronu yazımı silerdi.
  const handleChange = (str) => {
    if (!str) {
      onChange(null);
      return;
    }
    const dt = strToDate(str);
    if (dt) onChange(dt);
  };

  return (
    <div>
      {label ? (
        <label className="mb-1.5 flex h-7 items-center text-sm font-medium text-slate-700">{label}</label>
      ) : null}
      <CustomDatePicker value={dateToStr(value)} onChange={handleChange} onBlur={() => {}} />
      {hint ? <p className="mt-1.5 text-xs text-slate-500 leading-snug">{hint}</p> : null}
    </div>
  );
}

export default TarihGirisi;
